<template lang="pug">
v-flex(xs12)
  v-card.plan-card(flat)
    div.plan-card-top
      v-icon(color="#fff" size="18").mr-2 mdi-shield-check-outline
      span.plan-top-text Checkout protegido
    div.pa-4
      div.expande-horizontal
        v-avatar(rounded size="64" color="#f3f6ff")
          v-img(contain src="/img/logo_mini.png")
        div.ml-3
          div.plan-name {{ get_checkout.plan._id ? get_checkout.plan.name : 'Carregando plano...' }}
          div.plan-tag Assinatura mensal
      div.price-wrapper.mt-4
        span.plan-price {{ $helper.formataSaldo(get_checkout.plan._id ? get_checkout.plan.value_cents : 0) }}
        span.plan-price-label /mes
      v-chip.mt-4(small outlined color="#3158d3")
        v-icon(left size="14") mdi-lock-check-outline
        | Cobrança com validação de pagamento
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["get_checkout"])
  }
};
</script>

<style scoped>
.plan-card {
  border-radius: 16px;
  border: 1px solid #e9ecf5;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.08);
  overflow: hidden;
}

.plan-card-top {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: linear-gradient(135deg, #3158d3 0%, #2a8af6 100%);
}

.plan-top-text {
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}

.plan-name {
  font-size: 17px;
  font-weight: 700;
  color: #1f2937;
}

.plan-tag {
  font-size: 12px;
  color: #6b7280;
}

.price-wrapper {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.plan-price {
  font-size: 30px;
  line-height: 1;
  font-weight: 800;
  color: #0f172a;
}

.plan-price-label {
  font-size: 13px;
  color: #64748b;
}
</style>
